import { useNavigate } from '@tanstack/react-router';

import { scrollToSection } from 'src/utils/scroll-to-section';

import { Container } from './container';
import { Logo } from './logo';

export function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="bg-black py-12 md:py-24">
      <Container>
        <div className="flex flex-col items-center justify-between gap-20 text-white md:flex-row md:gap-0">
          <div className="flex flex-col items-center gap-4 text-center md:items-start md:text-left">
            <Logo />
            <h4 className="shrink-0 text-left text-2xl tracking-[-0.02em]">Camila & Adrián</h4>
            <div className="text-base font-light opacity-80">
              Copyright © {new Date().getFullYear()}
            </div>
          </div>

          <div className="flex flex-col gap-4 text-center md:gap-2 md:text-right">
            {[
              { label: 'Acerca', href: '#intro' },
              { label: 'Programa', href: '#programa' },
              { label: 'Regalos', href: '#regalos' },
              { label: 'Confirmar asistencia', href: '/form', navigate: true },
            ].map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-base uppercase hover:underline"
                onClick={(e) => {
                  e.preventDefault();
                  if (item.navigate) {
                    navigate({ to: '/form' });
                  } else {
                    scrollToSection(item.href, navigate);
                  }
                }}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </Container>
    </footer>
  );
}
